import { useState, Dispatch, SetStateAction } from "react";
import { generateInterview } from "src/services/job";
import { IJob } from "src/models";
import {
  Table,
  TableBody,
  TableCaption,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "src/shadcn/ui/table";
import { Loading } from "src/components/common";
// import {
//   Tooltip,
//   TooltipContent,
//   TooltipProvider,
//   TooltipTrigger,
// } from "src/shadcn/ui/tooltip";
import { Button } from "src/shadcn/ui/button";
// import { RefreshCcw } from "lucide-react";
import { useLocation, useNavigate } from "react-router-dom";

interface Props {
  currentJob: IJob;
  setCurrentJob: Dispatch<SetStateAction<IJob | null>>;
}

const InterviewPreparation: React.FC<Props> = ({
  currentJob,
  setCurrentJob,
}) => {
  const navigate = useNavigate();
  const location = useLocation();

  // states
  const [isLoading, setIsLoading] = useState<boolean>(false);

  // functions
  const handleGenerateInterview = async () => {
    setIsLoading(true);
    const res = await generateInterview(currentJob.id);
    setIsLoading(false);

    if (res) {
      setCurrentJob({ ...res });
    }
  };

  const handleBack = () => {
    navigate(`${location.pathname}?step=5`);
  };

  return (
    <div className="w-full grow relative pb-14">
      {isLoading ? (
        <div className="w-full h-[40vh] flex justify-center items-center">
          <Loading />
        </div>
      ) : (
        <>
          {currentJob?.interview_questions &&
          currentJob?.interview_questions?.length > 0 ? (
            <div className="border rounded-md overflow-hidden mt-6">
              <Table>
                <TableCaption className="hidden">
                  A list of your recent invoices.
                </TableCaption>
                <TableHeader className="bg-gray-300">
                  <TableRow className="border-b">
                    <TableHead className="font-bold text-black dark:text-white">
                      Category
                    </TableHead>
                    <TableHead className="font-bold text-black dark:text-white">
                      Targeted interview questions
                    </TableHead>
                  </TableRow>
                </TableHeader>
                <TableBody>
                  {currentJob?.interview_questions?.map((question, i) => (
                    <TableRow
                      key={`question-${i}`}
                      className="border-b"
                    >
                      <TableCell className="text-sm">
                        {question.category}
                      </TableCell>
                      <TableCell className="text-sm">
                        {question.content}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </div>
          ) : (
            <div className="w-full h-[40vh] flex items-center justify-center">
              <p className="text-sm">
                No interview questions, please click generate
              </p>
            </div>
          )}

          {/* <div className="flex mt-6 justify-end gap-2">
            <TooltipProvider>
              <Tooltip>
                <TooltipTrigger asChild>
                  <Button
                    variant="ghost"
                    disabled={isLoading}
                    className="p-1 h-fit"
                    onClick={handleGenerateInterview}
                  >
                    <RefreshCcw className="size-4" />
                  </Button>
                </TooltipTrigger>
                <TooltipContent className="dark:text-white text-black text-sm">
                  Generate interview question
                </TooltipContent>
              </Tooltip>
            </TooltipProvider>
          </div> */}
        </>
      )}

      <div className="flex justify-end gap-3 absolute bottom-0 right-0">
        <Button
          disabled={isLoading}
          variant="outline"
          className=""
          onClick={handleBack}
        >
          Back
        </Button>
        <Button onClick={handleGenerateInterview}>
          Get interview questions
        </Button>
      </div>
    </div>
  );
};

export default InterviewPreparation;
